let counter = 0;

/** Client-side unique id for UI keys (toasts, optimistic rows, pending files). */
export function createId(): string {
  // randomUUID() requires a secure context (HTTPS or localhost). LAN HTTP
  // dev setups need a fallback — getRandomValues still works there.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID();
    } catch {
      // Not a secure context (e.g. http://192.168.x.x) — fall through.
    }
  }

  // No Web Crypto at all (very old runtime). Ids here are only DOM keys, so a
  // monotonic counter is enough — and avoids a weak-random fallback.
  if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
    counter += 1;
    return `id-${Date.now().toString(36)}-${counter.toString(36)}`;
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // UUID v4 variant bits
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
